// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetVillageSuggestsRequest,
  TGetVillageSuggestsModel,
  IMappers,
  TGetVillageSuggestsResponse,
  IGetVillageSuggestsResponse,
  IGetVillageSuggestsResponseError,
} from './types';

export const defaultConfig: TGetVillageSuggestsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'countryside-search',
  pathApi: '/v1/get-village-suggests/',
} as TGetVillageSuggestsModel;

export function createGetVillageSuggestsModel(parameters: IGetVillageSuggestsRequest): TGetVillageSuggestsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetVillageSuggestsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetVillageSuggestsRequest;
}

export async function fetchGetVillageSuggests<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVillageSuggestsOptions<TResponse200, TResponse400>): Promise<
  TGetVillageSuggestsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetVillageSuggestsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVillageSuggestsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetVillageSuggestsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetVillageSuggestsResponse;
}
